import { useEffect, useRef, useState } from "react";
import { getApi, JSONParse, ORGANIZATIONS_PREFIX, PUBLIC_PREFIX } from "@cti-workspace/helpers";
import DraftCert from "./DraftCert";
import SimpleCert from "./SimpleCert";
import FabricCert from "./FabricCert";
import { getObjectValue } from "../utils/commonUtilityFunctions";
// import useWindowDimensions from "../../../hooks/useWindowDimensions";
import RenderLoadView from "../renderer/RenderLoadView";
import { Dialog } from "@cti-workspace/ui";
import { useSnackbar } from "notistack";

const CertView = ({
	componentRef,
	document,
	url,
	setIsDraft,
	renderConfigID,
	locale,
	setPrintPageSize = () => {},
	setCertBgImg = () => {},
	setFabricPageNames = () => {},
	activePageName = "",
	fabricCertiFullPageRef,
	downloadPdf,
	usedNewApi,
	renderConfig,
  theme,
  fallbackBackgroundImg,
}) => {
	const [config, setconfig] = useState({});
	const [ready, setready] = useState(false);
	const [zoomCertificate, setZoomCertificate] = useState(false);
	const [showSimple, setShowSimple] = useState(false);
	const snackbarInitiated = useRef(false);
	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(url);
		const parsedURLObj = Object.fromEntries(urlSearchParams.entries());
		const parsedURLArr = Object.keys(parsedURLObj).map(function (key) {
			const { [key]: value } = parsedURLObj;
			return value;
		});

		(async function iife() {
			if (usedNewApi) {
				try {
					setconfig({
						...renderConfig,
						data: JSON.stringify(renderConfig.data),
					});
					setready(true);
				} catch (err) {
					setready(true);
					setShowSimple(true);
					if (!snackbarInitiated.current) {
						snackbarInitiated.current = true;
						enqueueSnackbar("WARNING: Due to some error we are not able display your credential. please contact support.", { variant: "warning" });
					}
					console.error(err);
				}
			} else {
				if (renderConfigID) {
					try {
						let newConfigData = await getApi(`/${PUBLIC_PREFIX}/rendererConfig/${renderConfigID}`, { cachePolicy: "no-cache" }, false);
						setconfig(newConfigData);
						if (newConfigData.data) {
							if (getObjectValue(JSONParse(newConfigData?.data).value, "type", "") != "fabricDesign") {
								setIsDraft(true);
								const { style } = JSONParse(newConfigData?.data).value;
								if (style) {
									const { backgroundImage } = JSON.parse(style);
									const bgUrl = /(?:\(['"]?)(.*?)(?:['"]?\))/.exec(backgroundImage)[1];
									setCertBgImg(bgUrl);
								}
							}
						}

						setready(true);
					} catch (err) {
						setready(true);
						setShowSimple(true);
						if (!snackbarInitiated.current) {
							snackbarInitiated.current = true;
							enqueueSnackbar("WARNING: Due to some error we are not able display your credential. please contact support.", { variant: "warning" });
						}
						console.error(err);
					}
				} else {
					try {
						let newConfigData = await getApi(`/${ORGANIZATIONS_PREFIX}/renderers/getConfig/?orgId=${parsedURLArr[0]}&rendererId=${parsedURLArr[1]}`, { cachePolicy: "no-cache" }, false);

						if (newConfigData.data) {
							if (getObjectValue(JSONParse(newConfigData?.data).value, "type", "") != "fabricDesign") {
								setIsDraft(true);
							}
						}

						setconfig(newConfigData);
						setready(true);
					} catch (err) {
						setShowSimple(true);
						if (!snackbarInitiated.current) {
							snackbarInitiated.current = true;
							enqueueSnackbar("WARNING: Due to some error we are not able display your credential. please contact support.", { variant: "warning" });
						}
						console.error(err);
					}
				}
			}
		})();
	}, []);

	const getCurrentComponent = (isFullScreen) => {
		if (ready) {
			if (document.additionalData && document.additionalData.rendererConfigId) {
				return (
					<div>
						{config.type === "covid" && (
							<SimpleCert ref={isFullScreen ? null : componentRef} document={document} onClose={() => setZoomCertificate(false)} onZoom={() => setZoomCertificate(true)} config={config} isFullScreen={isFullScreen} setCertBgImg={setCertBgImg} />
						)}
						{renderConfigID === "HEALTH_CERT" && <div>null</div>}
						{getObjectValue(config, "simpleDesign", false) || showSimple ? (
							<SimpleCert
								ref={isFullScreen ? null : componentRef}
								config={JSONParse(config?.data).value}
								onClose={() => setZoomCertificate(false)}
								onZoom={() => setZoomCertificate(true)}
								document={document}
								isFullScreen={isFullScreen}
								setCertBgImg={setCertBgImg}
							/>
						) : getObjectValue(JSONParse(config?.data).value, "type", "") === "fabricDesign" ? (
							<FabricCert
								ref={isFullScreen ? null : componentRef}
								fabricCertiFullPageRef={fabricCertiFullPageRef}
								onClose={() => setZoomCertificate(false)}
								onZoom={() => setZoomCertificate(true)}
								document={document}
								isFullScreen={isFullScreen}
								config={JSONParse(config?.data).value}
								locale={locale}
								setCertBgImg={setCertBgImg}
								setPrintPageSize={setPrintPageSize}
								setFabricPageNames={setFabricPageNames}
								activePageName={activePageName}
								setShowSimple={setShowSimple}
								enqueueSnackbar={enqueueSnackbar}
								downloadPdf={downloadPdf}
                theme={theme}
                fallbackBackgroundImg={fallbackBackgroundImg}
							/>
						) : (
							<DraftCert
								ref={isFullScreen ? null : componentRef}
								document={document}
								isFullScreen={isFullScreen}
								onClose={() => setZoomCertificate(false)}
								onZoom={() => setZoomCertificate(true)}
								config={config}
								setShowSimple={setShowSimple}
								enqueueSnackbar={enqueueSnackbar}
							/>
						)}
					</div>
				);
			} else {
				return (
					<SimpleCert
						ref={isFullScreen ? null : componentRef}
						isFullScreen={isFullScreen}
						document={document}
						onClose={() => setZoomCertificate(false)}
						onZoom={() => setZoomCertificate(true)}
						config={getObjectValue(document, "config.designType") === "simpleDesign" ? document?.config : null}
					/>
				);
			}
		} else {
			return <RenderLoadView color={theme && theme?.primaryColor} />;
		}
	};

	return (
		<div id={"zoomed-out-certificate"}>
			{getCurrentComponent()}
			<Dialog open={zoomCertificate} disableBackdropClick={false} maxWidth="lg" borderRadius="8px" onClose={() => setZoomCertificate(false)} isDialogContainerActive={false}>
				<div id={"zoomed-certificate"}>{getCurrentComponent(true)}</div>
			</Dialog>
		</div>
	);
};

export default CertView;
